/* eslint-disable no-console */
import Enums from '../constants/Enums';

class Logger {
  static warn(message) {
    try {
      if(message){
        console.warn(`${Enums.loggerLevels.WARNING} ${message}`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  static info(message) {
    try {
      if(message){
        console.info(`${Enums.loggerLevels.INFO} ${message}`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  static error(message) {
    try {
      if(message){
        console.error(`${Enums.loggerLevels.ERROR} ${message}`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  static fatal(message) {
    try {
      if(message){
        console.trace(`${Enums.loggerLevels.FATAL} ${message}`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  static getCallbacks(action) {
    return {
      success(data) {
        Logger.info(`Succeeded: ${action}, data=${data}`);
      },
      failure(error) {
        Logger.error(`Failed: ${action}, error=${error}`);
      },
    };
  }

  static stateUpdateLogging(
    message,
    oldState,
    newState,
    isAgentStatus = false,
  ) {
    const oldStateType = oldState !== null
      ? oldState.type
      : null;

    const newStateType = newState !== null
      ? newState.type
      : null;

    if (!isAgentStatus) {
      return oldStateType !== newStateType
        ? `${message}: ${oldStateType} -> ${newStateType}`
        : `${message}: No Change`;
    }

    const oldStateName = oldState !== null
      ? oldState.name
      : null;

    const newStateName = newState !== null
      ? newState.name
      : null;

    return oldStateType !== newStateType || oldStateName !== newStateName
      ? `${message}: ${oldStateType}(${oldStateName}) -> `
        + `${newStateType}(${newStateName})`
      : `${message}: No Change`;
  }
}

export default Logger;
